// AMERİKA CİKLETLERİ + CÜCE CİKLETLER - balikVeritabani3.js
// Wikipedia Commons ücretsiz resimler kullanılmıştır

export const amerikaCikletleri = {
  kategori: {
    id: 'amerika-cikletleri',
    isim: 'Amerika Cikletleri',
    emoji: '🎣',
    renk: '#e67e22',
    aciklama: 'Güney ve Orta Amerika cikletleri - Oscar, Severum, Angel, Discus ve daha fazlası'
  },
  baliklar: [
    {
      id: 'oscar',
      isim: 'Oscar',
      latince: 'Astronotus ocellatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Astronotus_ocellatus.jpg/1280px-Astronotus_ocellatus.jpg',
      zorluk: 'Orta',
      genel: 'Güney Amerika\'nın en popüler büyük cikletlerinden. Çok zeki, sahibini tanır. "Su köpeği" olarak bilinir. Amazon havzası kökenli.',
      minLitre: 400,
      maxBoy: 35,
      sicaklik: { min: 23, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '15-20 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Karnivor - Pellet, balık, karides, böcek. Canlı yem sever ama parazit riski.',
      uyumlu: ['Diğer büyük cikletler', 'Büyük Pleco', 'Silver Dollar', 'Bichir'],
      uyumsuz: ['Küçük tüm balıklar (yem olur)', 'Agresif eşit boy balıklar'],
      ureme: 'Substrat yumurtlayıcı. Düz yüzeye 1000-2000 yumurta.',
      eslesme: 'Çift bağı kurar. Birlikte yavru bakar. Çift seçimi zor olabilir.',
      grupSayisi: 'Tek veya çift',
      disiErkek: 'Cinsiyet ayrımı zor. Çift uyumu önemli.',
      gorunus: 'Büyük, oval vücut. Tiger Oscar (turuncu-siyah desenli), Red Oscar, Albino Oscar, Lemon Oscar varyasyonları. Kuyruk dibinde göz lekesi (ocellus).',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'angel',
      isim: 'Angel (Melek Balığı)',
      latince: 'Pterophyllum scalare',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Pterophyllum_scalare_-_freshwater_angelfish.jpg/1280px-Pterophyllum_scalare_-_freshwater_angelfish.jpg',
      zorluk: 'Orta',
      genel: 'Zarif görünümüyle akvaryumculuğun sembol balıklarından. Amazon kökenli. Uzun yüzgeçleri ile tanınır.',
      minLitre: 200,
      maxBoy: 15,
      sicaklik: { min: 24, max: 30 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 3, max: 10 },
      yasam: '10-15 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Pul, pellet, canlı ve dondurulmuş yem.',
      uyumlu: ['Orta boy Tetralar', 'Corydoras', 'Pleco', 'Rasbora', 'Barışçıl orta boy balıklar'],
      uyumsuz: ['Küçük Tetralar (Neon vb. - yem olur)', 'Yüzgeç ısırıcılar', 'Çok aktif balıklar'],
      ureme: 'Substrat yumurtlayıcı. Dikey yüzeylere (bitki yaprağı, cam) yumurta.',
      eslesme: 'Güçlü çift bağı. Birlikte yumurta ve yavru korur.',
      grupSayisi: '6+ genç, sonra çift oluşur',
      disiErkek: 'Cinsiyet ayrımı zor. Genç grup al, çift oluşmasını bekle.',
      gorunus: 'Yuvarlak, yanal yassı vücut. Çok uzun sırt ve anal yüzgeçler. Silver, Marble, Koi, Black, Gold, Platinum, Zebra varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'discus',
      isim: 'Discus',
      latince: 'Symphysodon aequifasciatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Discus_fish.jpg/1280px-Discus_fish.jpg',
      zorluk: 'Zor',
      genel: 'Akvaryum balıklarının kralı. Amazon\'un siyah sularından. Çok hassas, mükemmel su kalitesi gerektirir.',
      minLitre: 300,
      maxBoy: 20,
      sicaklik: { min: 28, max: 32 },
      ph: { min: 5.5, max: 7.0 },
      sertlik: { min: 1, max: 5 },
      yasam: '10-15 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Discus peleti, beefheart karışımı, dondurulmuş yem. Günde birkaç kez besleme.',
      uyumlu: ['Diğer Discus', 'Cardinal Tetra', 'Rummy Nose', 'Sterbai Cory', 'Pleco'],
      uyumsuz: ['Agresif balıklar', 'Hızlı yem rakipleri', 'Soğuk su balıkları'],
      ureme: 'Substrat yumurtlayıcı. Yavrular ebeveynlerin vücut mukusunu yer!',
      eslesme: 'Güçlü çift bağı. Benzersiz yavru besleme davranışı.',
      grupSayisi: '6+ (sürü balığı)',
      disiErkek: 'Cinsiyet ayrımı çok zor.',
      gorunus: 'Disk şeklinde vücut. Pigeon Blood, Blue Diamond, Leopard, Turquoise, Red Melon gibi yüzlerce renk formu.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'severum',
      isim: 'Severum',
      latince: 'Heros severus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Heros_severus_2.jpg/1280px-Heros_severus_2.jpg',
      zorluk: 'Orta',
      genel: 'Poor Man\'s Discus olarak da bilinir. Discus\'a benzer şekil ama çok daha dayanıklı. Başlangıç için iyi büyük ciklet.',
      minLitre: 300,
      maxBoy: 25,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '10-15 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Pellet, sebze, canlı yem. Bitkisel içerik önemli.',
      uyumlu: ['Diğer orta-büyük barışçıl cikletler', 'Büyük Tetralar', 'Pleco'],
      uyumsuz: ['Küçük balıklar', 'Çok agresif türler'],
      ureme: 'Substrat yumurtlayıcı.',
      eslesme: 'Çift bağı kurar.',
      grupSayisi: 'Çift veya tek',
      disiErkek: 'Erkeklerde yüz çizgileri daha belirgin.',
      gorunus: 'Oval, yanlardan basık. Green Severum (doğal), Gold Severum (sarı), Red Shoulder Severum. Yüzde kırmızı-turuncu desenler.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'green-terror',
      isim: 'Green Terror',
      latince: 'Andinoacara rivulatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Andinoacara_rivulatus.jpg/1280px-Andinoacara_rivulatus.jpg',
      zorluk: 'Orta',
      genel: 'Ekvador ve Peru kökenli. Adına rağmen makul agresyon seviyesi. Metalik yeşil-mavi renkleri çarpıcı.',
      minLitre: 300,
      maxBoy: 25,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.5, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '10-15 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Omnivor - Pellet, canlı yem, dondurulmuş yem.',
      uyumlu: ['Eşit boy dayanıklı cikletler', 'Büyük Pleco', 'Silver Dollar'],
      uyumsuz: ['Küçük balıklar', 'Yavaş/barışçıl türler'],
      ureme: 'Substrat yumurtlayıcı.',
      eslesme: 'Çift, üreme döneminde çok agresif olabilir.',
      grupSayisi: 'Çift veya tek',
      disiErkek: 'Erkeklerde baş çıkıntısı ve daha uzun yüzgeçler.',
      gorunus: 'Metalik yeşil-mavi vücut, turuncu yüzgeç kenarları. Erkeklerde belirgin baş çıkıntısı.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'jack-dempsey',
      isim: 'Jack Dempsey',
      latince: 'Rocio octofasciata',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Jack_Dempsey_fish.jpg/1280px-Jack_Dempsey_fish.jpg',
      zorluk: 'Orta',
      genel: 'Ünlü boksör Jack Dempsey\'den adını alır. Orta Amerika kökenli. Agresif ama yönetilebilir.',
      minLitre: 300,
      maxBoy: 25,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.5, max: 8.0 },
      sertlik: { min: 8, max: 15 },
      yasam: '10-15 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Karnivor - Pellet, canlı yem, balık.',
      uyumlu: ['Eşit boy güçlü cikletler', 'Büyük Pleco'],
      uyumsuz: ['Küçük balıklar', 'Barışçıl türler'],
      ureme: 'Substrat yumurtlayıcı.',
      eslesme: 'Çift, agresif ebeveynler.',
      grupSayisi: 'Tek veya çift',
      disiErkek: 'Erkekler daha büyük, daha uzun yüzgeçler.',
      gorunus: 'Koyu mavi-mor üzerinde metalik mavi-yeşil pullar. Electric Blue Jack Dempsey varyasyonu çok popüler.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'electric-blue-jack-dempsey',
      isim: 'Electric Blue Jack Dempsey',
      latince: 'Rocio octofasciata var.',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Electric_Blue_Jack_Dempsey.jpg/1280px-Electric_Blue_Jack_Dempsey.jpg',
      zorluk: 'Orta',
      genel: 'Normal Jack Dempsey\'nin doğal mutant formu. Daha küçük ve daha az agresif. Muhteşem elektrik mavisi.',
      minLitre: 200,
      maxBoy: 20,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 8, max: 15 },
      yasam: '10-12 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Karnivor - Yüksek kalite pellet, dondurulmuş yem.',
      uyumlu: ['Orta boy barışçıl cikletler', 'Büyük Tetralar'],
      uyumsuz: ['Çok agresif türler', 'Küçük balıklar'],
      ureme: 'Substrat yumurtlayıcı. Üremesi zor.',
      eslesme: 'Çift.',
      grupSayisi: 'Tek veya çift',
      disiErkek: 'Erkekler daha büyük.',
      gorunus: 'Tüm vücut parlak elektrik mavisi. Çok gösterişli.',
      kaynaklar: ['cichlid-forum.com']
    },
    {
      id: 'firemouth',
      isim: 'Firemouth',
      latince: 'Thorichthys meeki',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Thorichthys_meeki.jpg/1280px-Thorichthys_meeki.jpg',
      zorluk: 'Kolay',
      genel: 'Orta Amerika klasiği. Kırmızı boğaz ve göğüsle tanınır. Tehdit gösterisi yaparak solungaç kapaklarını açar.',
      minLitre: 200,
      maxBoy: 15,
      sicaklik: { min: 23, max: 28 },
      ph: { min: 6.5, max: 8.0 },
      sertlik: { min: 8, max: 20 },
      yasam: '10-15 yıl',
      bolge: 'Alt ve Orta',
      beslenme: 'Omnivor - Pellet, canlı ve dondurulmuş yem.',
      uyumlu: ['Diğer Orta Amerika cikletleri', 'Orta boy topluluk balıkları'],
      uyumsuz: ['Çok küçük balıklar', 'Çok agresif türler'],
      ureme: 'Substrat yumurtlayıcı.',
      eslesme: 'Çift, iyi ebeveynler.',
      grupSayisi: 'Çift veya tek',
      disiErkek: 'Erkekler daha parlak kırmızı, daha uzun yüzgeçler.',
      gorunus: 'Gümüşi-mavi vücut, parlak kırmızı boğaz ve göğüs. Tehdit gösterisinde solungaç kapakları kırmızıyı sergiler.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'convict',
      isim: 'Convict Cichlid (Mahkum)',
      latince: 'Amatitlania nigrofasciata',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Convict_cichlid.jpg/1280px-Convict_cichlid.jpg',
      zorluk: 'Kolay',
      genel: 'En dayanıklı ve kolay üreyen ciklet. Mahkum çizgilerinden adını alır. Başlangıç için ideal ama çok ürer!',
      minLitre: 150,
      maxBoy: 15,
      sicaklik: { min: 20, max: 28 },
      ph: { min: 6.5, max: 8.0 },
      sertlik: { min: 8, max: 20 },
      yasam: '8-10 yıl',
      bolge: 'Alt ve Orta',
      beslenme: 'Omnivor - Her şeyi yer.',
      uyumlu: ['Dayanıklı eşit boy balıklar'],
      uyumsuz: ['Yavaş, barışçıl balıklar', 'Küçük balıklar'],
      ureme: 'Substrat yumurtlayıcı. ÇOK kolay ürer, kontrol gerekir.',
      eslesme: 'Agresif ebeveynler, mükemmel yavru bakımı.',
      grupSayisi: 'Tek veya çift',
      disiErkek: 'Dişilerde karında turuncu leke.',
      gorunus: 'Gri-mavi üzerinde siyah dikey çizgiler. Pink Convict, Black Convict varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'blood-parrot',
      isim: 'Blood Parrot',
      latince: 'Hibrit',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Blood_parrot_cichlid.jpg/1280px-Blood_parrot_cichlid.jpg',
      zorluk: 'Kolay',
      genel: 'Akvaryum oluşturulmuş hibrit (muhtemelen Midas x Red Devil veya Severum melezi). Kalp şekilli ağız. Tartışmalı etik.',
      minLitre: 200,
      maxBoy: 20,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '10-15 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Özel Blood Parrot peleti (küçük ağız için), dondurulmuş yem.',
      uyumlu: ['Barışçıl orta-büyük balıklar', 'Severum', 'Angel'],
      uyumsuz: ['Agresif balıklar (savunamaz)', 'Yem rakipleri'],
      ureme: 'Genellikle kısır. Nadir başarılı üreme.',
      eslesme: 'Erkekler genellikle kısır.',
      grupSayisi: 'Tek veya grup',
      disiErkek: 'Ayrımı zor.',
      gorunus: 'Yuvarlak vücut, kalp şekilli ağız. Parlak turuncu-kırmızı. Purple, King Kong (siyah lekeli) varyasyonları.',
      kaynaklar: ['cichlid-forum.com']
    },
    {
      id: 'flowerhorn',
      isim: 'Flowerhorn',
      latince: 'Hibrit',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Flowerhorn.jpg/1280px-Flowerhorn.jpg',
      zorluk: 'Orta',
      genel: 'Asya\'da oluşturulan hibrit. Büyük baş çıkıntısı (kok). Feng Shui\'de şans getirici. Tek başına tutulmalı.',
      minLitre: 300,
      maxBoy: 35,
      sicaklik: { min: 26, max: 30 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 8, max: 15 },
      yasam: '10-12 yıl',
      bolge: 'Orta',
      beslenme: 'Karnivor - Yüksek protein peleti, karides, balık.',
      uyumlu: ['HİÇBİRİ - tek tutulmalı'],
      uyumsuz: ['Tüm balıklar - çok agresif'],
      ureme: 'Hibrit, çoğu kısır.',
      eslesme: 'Çok agresif, eşi öldürebilir.',
      grupSayisi: 'SADECE TEK',
      disiErkek: 'Erkeklerde daha büyük kok.',
      gorunus: 'Büyük baş çıkıntısı (kok/nuchal hump). Parlak kırmızı, turuncu, mavi desenler. Kamfa, Zhen Zhu, Golden Monkey gibi tipler.',
      kaynaklar: ['cichlid-forum.com']
    },
    {
      id: 'geophagus',
      isim: 'Geophagus (Toprak Yiyen)',
      latince: 'Geophagus sveni',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Geophagus_altifrons.jpg/1280px-Geophagus_altifrons.jpg',
      zorluk: 'Orta',
      genel: 'Eartheater - kumu ağzına alıp eleyen barışçıl ciklet. Güney Amerika kökenli. Zarif ve ilginç davranış.',
      minLitre: 300,
      maxBoy: 25,
      sicaklik: { min: 26, max: 30 },
      ph: { min: 5.5, max: 7.0 },
      sertlik: { min: 2, max: 10 },
      yasam: '8-12 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Batan pellet, dondurulmuş yem, kum elemesi.',
      uyumlu: ['Diğer Geophagus', 'Tetralar', 'Corydoras', 'Barışçıl türler'],
      uyumsuz: ['Agresif cikletler', 'Dip rekabetçileri'],
      ureme: 'Ağız kuluçkacı veya substrat (türe göre).',
      eslesme: 'Grup içinde çift oluşur.',
      grupSayisi: '5-6 (sürü)',
      disiErkek: 'Erkekler daha büyük, daha uzun yüzgeçler.',
      gorunus: 'Zarif, uzun vücut. Metalik mavi-yeşil pullar, kırmızı yüzgeç detayları. G. altifrons, G. sveni, G. tapajos gibi türler.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'uaru',
      isim: 'Uaru',
      latince: 'Uaru amphiacanthoides',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Uaru_amphiacanthoides.jpg/1280px-Uaru_amphiacanthoides.jpg',
      zorluk: 'Zor',
      genel: 'Triangle Cichlid. Discus akrabası ama daha büyük. Bitkisel beslenen nadir ciklet.',
      minLitre: 400,
      maxBoy: 30,
      sicaklik: { min: 26, max: 30 },
      ph: { min: 5.0, max: 7.0 },
      sertlik: { min: 1, max: 8 },
      yasam: '10-15 yıl',
      bolge: 'Orta',
      beslenme: 'Herbivor ağırlıklı - Sebze, spirulina, bitkisel pellet. Bitkileri yer!',
      uyumlu: ['Discus', 'Büyük Tetralar', 'Geophagus'],
      uyumsuz: ['Agresif türler', 'Küçük balıklar'],
      ureme: 'Substrat yumurtlayıcı. Discus gibi yavru besleme.',
      eslesme: 'Çift, yavralar ebeveyn mukusu yer.',
      grupSayisi: '4-6',
      disiErkek: 'Ayrımı zor.',
      gorunus: 'Üçgen/kalp şekilli vücut. Kahverengi-gri, büyük siyah leke. Gençler benekli.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'acara-blue',
      isim: 'Blue Acara',
      latince: 'Andinoacara pulcher',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Andinoacara_pulcher.jpg/1280px-Andinoacara_pulcher.jpg',
      zorluk: 'Kolay',
      genel: 'Güzel, dayanıklı ve nispeten barışçıl. Başlangıç için iyi orta boy ciklet.',
      minLitre: 150,
      maxBoy: 16,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.5, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Orta boy topluluk balıkları', 'Diğer barışçıl cikletler'],
      uyumsuz: ['Küçük balıklar', 'Çok agresif türler'],
      ureme: 'Substrat yumurtlayıcı.',
      eslesme: 'Çift, iyi ebeveynler.',
      grupSayisi: 'Çift veya tek',
      disiErkek: 'Erkekler daha büyük, daha uzun yüzgeçler.',
      gorunus: 'Metalik mavi-yeşil vücut, turuncu yüzgeç kenarları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'electric-blue-acara',
      isim: 'Electric Blue Acara',
      latince: 'Andinoacara pulcher var.',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Electric_Blue_Acara.jpg/1280px-Electric_Blue_Acara.jpg',
      zorluk: 'Kolay',
      genel: 'Blue Acara\'nın selektif üretim formu. Daha parlak mavi, daha barışçıl.',
      minLitre: 150,
      maxBoy: 15,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Barışçıl topluluk balıkları', 'Tetralar', 'Corydoras'],
      uyumsuz: ['Agresif türler'],
      ureme: 'Substrat yumurtlayıcı.',
      eslesme: 'Çift.',
      grupSayisi: 'Çift veya tek',
      disiErkek: 'Erkekler biraz daha büyük.',
      gorunus: 'Parlak elektrik mavisi tüm vücut. Çok gösterişli.',
      kaynaklar: ['cichlid-forum.com']
    },
    {
      id: 'keyhole',
      isim: 'Keyhole Cichlid',
      latince: 'Cleithracara maronii',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Cleithracara_maronii.jpg/1280px-Cleithracara_maronii.jpg',
      zorluk: 'Kolay',
      genel: 'En barışçıl Güney Amerika cikletlerinden. Anahtar deliği şeklinde yandaki lekeden adını alır.',
      minLitre: 100,
      maxBoy: 12,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 3, max: 12 },
      yasam: '8-10 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Tetralar', 'Corydoras', 'Barışçıl topluluk balıkları'],
      uyumsuz: ['Agresif balıklar'],
      ureme: 'Substrat yumurtlayıcı.',
      eslesme: 'Çift, iyi ebeveynler.',
      grupSayisi: 'Çift veya tek',
      disiErkek: 'Ayrımı zor.',
      gorunus: 'Bej-kahverengi vücut, yanda anahtar deliği şeklinde siyah leke. Stres rengi değiştirir.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    }
  ]
};

export const cuceCikletler = {
  kategori: {
    id: 'cuce-cikletler',
    isim: 'Cüce Cikletler',
    emoji: '💎',
    renk: '#1abc9c',
    aciklama: 'Küçük boyutlu Güney Amerika cikletleri - Apistogramma, Ram ve diğerleri'
  },
  baliklar: [
    {
      id: 'german-blue-ram',
      isim: 'German Blue Ram',
      latince: 'Mikrogeophagus ramirezi',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Mikrogeophagus_ramirezi.jpg/1280px-Mikrogeophagus_ramirezi.jpg',
      zorluk: 'Orta',
      genel: 'En popüler cüce ciklet. Muhteşem mavi-sarı renkler. Hassas ama çok güzel.',
      minLitre: 80,
      maxBoy: 7,
      sicaklik: { min: 27, max: 30 },
      ph: { min: 5.5, max: 7.0 },
      sertlik: { min: 2, max: 8 },
      yasam: '2-4 yıl',
      bolge: 'Alt ve Orta',
      beslenme: 'Omnivor - Küçük pellet, canlı ve dondurulmuş yem.',
      uyumlu: ['Tetralar', 'Corydoras', 'Küçük barışçıl balıklar'],
      uyumsuz: ['Agresif balıklar', 'Büyük balıklar', 'Soğuk su balıkları'],
      ureme: 'Substrat yumurtlayıcı.',
      eslesme: 'Çift bağı kurar, birlikte yavru bakar.',
      grupSayisi: 'Çift',
      disiErkek: 'Erkeklerde daha uzun sırt yüzgeci ışınları, daha parlak.',
      gorunus: 'Sarı-altın vücut, elektrik mavisi noktalar ve çizgiler. Siyah göz bandı. Kırmızı göz. Gold, Electric Blue, Balloon varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'bolivian-ram',
      isim: 'Bolivian Ram',
      latince: 'Mikrogeophagus altispinosus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Mikrogeophagus_altispinosus.jpg/1280px-Mikrogeophagus_altispinosus.jpg',
      zorluk: 'Kolay',
      genel: 'German Ram\'ın daha dayanıklı kuzeni. Daha az renkli ama çok daha kolay bakılır. Başlangıç için ideal cüce ciklet.',
      minLitre: 80,
      maxBoy: 8,
      sicaklik: { min: 22, max: 27 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 3, max: 12 },
      yasam: '4-6 yıl',
      bolge: 'Alt ve Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Tetralar', 'Corydoras', 'Küçük barışçıl balıklar'],
      uyumsuz: ['Agresif balıklar'],
      ureme: 'Substrat yumurtlayıcı.',
      eslesme: 'Çift.',
      grupSayisi: 'Çift veya grup',
      disiErkek: 'Erkeklerde daha uzun yüzgeç uzantıları.',
      gorunus: 'Gümüşi-sarı vücut, kırmızı-turuncu yüzgeç kenarları. Siyah göz bandı ve yan leke.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'electric-blue-ram',
      isim: 'Electric Blue Ram',
      latince: 'Mikrogeophagus ramirezi var.',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Electric_Blue_Ram.jpg/1280px-Electric_Blue_Ram.jpg',
      zorluk: 'Zor',
      genel: 'German Ram\'ın selektif üretim formu. Nefes kesici mavi renk ama daha hassas.',
      minLitre: 80,
      maxBoy: 6,
      sicaklik: { min: 27, max: 30 },
      ph: { min: 5.5, max: 7.0 },
      sertlik: { min: 1, max: 6 },
      yasam: '2-3 yıl',
      bolge: 'Alt ve Orta',
      beslenme: 'Omnivor - Yüksek kalite yem gerekir.',
      uyumlu: ['Küçük barışçıl balıklar'],
      uyumsuz: ['Agresif türler', 'Yem rakipleri'],
      ureme: 'Substrat yumurtlayıcı. Üremesi zor.',
      eslesme: 'Çift.',
      grupSayisi: 'Çift',
      disiErkek: 'Erkekler biraz daha parlak.',
      gorunus: 'Tüm vücut parlak elektrik mavisi. Kırmızı göz.',
      kaynaklar: ['cichlid-forum.com']
    },
    {
      id: 'apistogramma-cacatuoides',
      isim: 'Cockatoo Apisto',
      latince: 'Apistogramma cacatuoides',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Apistogramma_cacatuoides.jpg/1280px-Apistogramma_cacatuoides.jpg',
      zorluk: 'Orta',
      genel: 'Papağan ibiği şeklinde sırt yüzgeci. En popüler ve en kolay Apistogramma türü.',
      minLitre: 80,
      maxBoy: 8,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 3, max: 15 },
      yasam: '3-5 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor - Canlı ve dondurulmuş yem tercih eder.',
      uyumlu: ['Tetralar', 'Corydoras', 'Küçük barışçıl balıklar'],
      uyumsuz: ['Diğer dip cikletleri (aynı alanda)', 'Büyük balıklar'],
      ureme: 'Mağara yumurtlayıcı.',
      eslesme: 'Harem sistemi. 1 erkek birden fazla dişiyle.',
      grupSayisi: '1 erkek / 2-3 dişi',
      disiErkek: 'Erkekler çok daha renkli, büyük ve uzun yüzgeçli.',
      gorunus: 'Erkekler: Sarı-turuncu vücut, kırmızı-turuncu yüzgeçler, papağan ibiği şeklinde sırt yüzgeci. Dişiler: Sarımsı, daha sade. Double Red, Triple Red, Orange Flash varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'apistogramma-agassizii',
      isim: 'Agassiz\'s Dwarf Cichlid',
      latince: 'Apistogramma agassizii',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Apistogramma_agassizii_male.jpg/1280px-Apistogramma_agassizii_male.jpg',
      zorluk: 'Orta',
      genel: 'Mızrak şeklinde kuyrukla tanınır. Amazon kökenli. Birçok renk formu.',
      minLitre: 80,
      maxBoy: 9,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 5.5, max: 7.0 },
      sertlik: { min: 1, max: 10 },
      yasam: '3-5 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor - Canlı ve dondurulmuş yem.',
      uyumlu: ['Tetralar', 'Küçük barışçıl balıklar'],
      uyumsuz: ['Diğer dip cikletleri', 'Büyük balıklar'],
      ureme: 'Mağara yumurtlayıcı.',
      eslesme: 'Harem sistemi.',
      grupSayisi: '1 erkek / 2-3 dişi',
      disiErkek: 'Erkekler çok daha renkli ve büyük.',
      gorunus: 'Mızrak şeklinde kuyruk. Fire Red, Gold, Blue gibi renk formları. Erkekler mavi-sarı-kırmızı.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'apistogramma-borellii',
      isim: 'Umbrella Cichlid',
      latince: 'Apistogramma borellii',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Apistogramma_borellii_male.jpg/1280px-Apistogramma_borellii_male.jpg',
      zorluk: 'Orta',
      genel: 'Şemsiye şeklinde sırt yüzgeci. Daha soğuğa toleranslı Apistogramma türü.',
      minLitre: 60,
      maxBoy: 6,
      sicaklik: { min: 20, max: 26 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 2, max: 12 },
      yasam: '3-5 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor',
      uyumlu: ['Küçük barışçıl balıklar'],
      uyumsuz: ['Diğer dip cikletleri', 'Büyük balıklar'],
      ureme: 'Mağara yumurtlayıcı.',
      eslesme: 'Çift veya harem.',
      grupSayisi: '1 erkek / 1-2 dişi',
      disiErkek: 'Erkekler daha renkli, yüksek sırt yüzgeci.',
      gorunus: 'Mavi-sarı renk. Yüksek, yuvarlak sırt yüzgeci. Yellow Face, Opal formları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'apistogramma-hongsloi',
      isim: 'Hongsloi',
      latince: 'Apistogramma hongsloi',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Apistogramma_hongsloi.jpg/1280px-Apistogramma_hongsloi.jpg',
      zorluk: 'Orta',
      genel: 'Kolombiya ve Venezuela kökenli. Erkeklerin kırmızı yanakları çarpıcı.',
      minLitre: 80,
      maxBoy: 7,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 5.5, max: 7.0 },
      sertlik: { min: 1, max: 8 },
      yasam: '3-5 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor',
      uyumlu: ['Tetralar', 'Küçük barışçıl balıklar'],
      uyumsuz: ['Diğer Apistogramma'],
      ureme: 'Mağara yumurtlayıcı.',
      eslesme: 'Harem.',
      grupSayisi: '1 erkek / 2 dişi',
      disiErkek: 'Erkekler kırmızı yanak lekeleri, daha uzun yüzgeçler.',
      gorunus: 'Sarı-mavi vücut, belirgin kırmızı yanak lekeleri erkeklerde. Form II en renkli.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'apistogramma-trifasciata',
      isim: 'Three-Striped Apisto',
      latince: 'Apistogramma trifasciata',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/Apistogramma_trifasciata.jpg/1280px-Apistogramma_trifasciata.jpg',
      zorluk: 'Orta',
      genel: 'Üç çizgili Apisto. Paraguay ve Güney Brezilya kökenli. Nispeten kolay bakılır.',
      minLitre: 60,
      maxBoy: 5,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 2, max: 12 },
      yasam: '3-5 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor',
      uyumlu: ['Küçük barışçıl balıklar'],
      uyumsuz: ['Diğer Apistogramma'],
      ureme: 'Mağara yumurtlayıcı.',
      eslesme: 'Çift veya harem.',
      grupSayisi: '1 erkek / 1-2 dişi',
      disiErkek: 'Erkekler daha renkli.',
      gorunus: 'Üç belirgin yatay çizgi. Mavi-sarı renkler.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'apistogramma-macmasteri',
      isim: 'MacMaster\'s Apisto',
      latince: 'Apistogramma macmasteri',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Apistogramma_macmasteri.jpg/1280px-Apistogramma_macmasteri.jpg',
      zorluk: 'Orta',
      genel: 'Kolombiya kökenli. Kırmızı kuyruk kenarı ile tanınır. Red Tail olarak da bilinir.',
      minLitre: 80,
      maxBoy: 7,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 5.5, max: 7.0 },
      sertlik: { min: 1, max: 8 },
      yasam: '3-5 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor',
      uyumlu: ['Tetralar', 'Corydoras'],
      uyumsuz: ['Diğer Apistogramma'],
      ureme: 'Mağara yumurtlayıcı.',
      eslesme: 'Harem.',
      grupSayisi: '1 erkek / 2 dişi',
      disiErkek: 'Erkekler çok daha renkli.',
      gorunus: 'Mavi-sarı vücut, belirgin kırmızı kuyruk kenarı. Dişiler sarı.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'kribensis',
      isim: 'Kribensis',
      latince: 'Pelvicachromis pulcher',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Pelvicachromis_pulcher_female.jpg/1280px-Pelvicachromis_pulcher_female.jpg',
      zorluk: 'Kolay',
      genel: 'Batı Afrika\'nın en popüler cüce cikleti. Çok dayanıklı ve kolay ürer. Rainbow Krib olarak da bilinir.',
      minLitre: 80,
      maxBoy: 10,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-8 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Tetralar', 'Barb', 'Corydoras', 'Topluluk balıkları'],
      uyumsuz: ['Diğer dip cikletleri (üreme döneminde)'],
      ureme: 'Mağara yumurtlayıcı. Çok kolay ürer.',
      eslesme: 'Güçlü çift bağı. Mükemmel ebeveynler.',
      grupSayisi: 'Çift',
      disiErkek: 'Dişilerde pembe-kırmızı karın. Erkekler daha büyük, sivri yüzgeçler.',
      gorunus: 'Erkekler: Sarımsı-gri, mavi yüzgeç detayları. Dişiler: Parlak pembe-mor karın, daha renkli.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'nanochromis-parilus',
      isim: 'Nanochromis',
      latince: 'Nanochromis parilus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Nanochromis_parilus_male.jpg/1280px-Nanochromis_parilus_male.jpg',
      zorluk: 'Orta',
      genel: 'Kongo havzası cüce cikleti. Kribensis\'e benzer ama farklı cins.',
      minLitre: 80,
      maxBoy: 8,
      sicaklik: { min: 24, max: 27 },
      ph: { min: 5.5, max: 7.0 },
      sertlik: { min: 2, max: 10 },
      yasam: '5-8 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Tetralar', 'Barışçıl topluluk balıkları'],
      uyumsuz: ['Diğer dip cikletleri'],
      ureme: 'Mağara yumurtlayıcı.',
      eslesme: 'Çift.',
      grupSayisi: 'Çift',
      disiErkek: 'Dişiler daha renkli (Kribensis gibi).',
      gorunus: 'Gri-kahverengi vücut, mavi yansımalar. Dişilerde mor karın.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'dicrossus-filamentosus',
      isim: 'Checkerboard Cichlid',
      latince: 'Dicrossus filamentosus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Dicrossus_filamentosus.jpg/1280px-Dicrossus_filamentosus.jpg',
      zorluk: 'Zor',
      genel: 'Dama tahtası deseni. Çok yumuşak su gerektirir. Hassas ama güzel.',
      minLitre: 80,
      maxBoy: 9,
      sicaklik: { min: 26, max: 30 },
      ph: { min: 4.5, max: 6.5 },
      sertlik: { min: 0, max: 4 },
      yasam: '3-5 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor - Canlı ve dondurulmuş yem.',
      uyumlu: ['Cardinal Tetra', 'Diğer yumuşak su balıkları'],
      uyumsuz: ['Sert su balıkları', 'Agresif türler'],
      ureme: 'Substrat yumurtlayıcı.',
      eslesme: 'Harem sistemi.',
      grupSayisi: '1 erkek / 2-3 dişi',
      disiErkek: 'Erkeklerde lir kuyruk, daha uzun yüzgeçler.',
      gorunus: 'Dama tahtası deseni - siyah kareler satırı. Erkeklerin kuyrukları lir şeklinde uzar.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    }
  ]
};

export default { amerikaCikletleri, cuceCikletler };